import { api } from '../../common/api/httpClient';
import type { AuthSession } from '../../model/portalModels';
import type { PlatformPermissionContext } from '@jukun/platform-sdk/auth';

export const authApi = {
  defaultFeishuApp() {
    return api<{ appId: string | null }>('/api/auth/feishu/default-app');
  },
  permissionContext(applicationCode: string, signal?: AbortSignal) {
    return api<PlatformPermissionContext>(
      `/api/portal/applications/${encodeURIComponent(applicationCode)}/permission-context`,
      { signal },
    );
  },
  login(identifier: string, password: string) {
    return api<AuthSession>('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ identifier, password }),
    });
  },
  feishuSession(appId: string, code: string, signal?: AbortSignal, redirectUri?: string) {
    return api<AuthSession>('/api/auth/feishu/session', {
      method: 'POST',
      signal,
      body: JSON.stringify({ appId, code, ...(redirectUri ? { redirectUri } : {}) }),
    });
  },
  current(feishuAppId?: string) {
    const query = feishuAppId === undefined ? '' : `?feishuAppId=${encodeURIComponent(feishuAppId)}`;
    return api<AuthSession>(`/api/auth/session${query}`);
  },
  async logout() {
    await api<void>('/api/auth/session', { method: 'DELETE' });
  },
  accessToken(applicationCode: string, signal?: AbortSignal) {
    return api<{
      accessToken: string;
      expiresAt: string;
      applicationCode: string;
      scopes: string[];
    }>('/api/auth/access-tokens', {
      method: 'POST',
      signal,
      body: JSON.stringify({ applicationCode }),
    });
  },
};
